import React, { memo } from 'react'

import * as S from './styles'

export type CardProps = PropsWithRequiredChildren<DefaultHTMLAttrs<HTMLDivElement>> & {
  useShadow?: boolean
}

export const Component = ({ children, ...attrs }: CardProps) => (
  <S.Container {...attrs}>{children}</S.Container>
)

/**
 * - [`Inter UI Documentation`](https://inter-ui.bancointer.com.br/?path=/story/pages-utils-card-since-v2-0-39--default)
 *
 * **Code example**
 * ```tsx
 * import React from 'react'
 *
 * import { Card } from '@interco/inter-ui/components/Card'
 *
 * export const MyPage = () => {
 *   return (
 *     <Card>
 *       Thundercats four dollar toast bespoke selvage cray health goth photo
 *       booth squid williamsburg tattooed. Fashion axe XOXO pug, coloring book
 *       lomo pinterest vinyl pop-up. Mixtape YOLO viral, af kogi artisan banjo
 *       try-hard chia. Hammock kinfolk narwhal fingerstache, williamsburg cred
 *       stumptown leggings ennui 90&apos;s food truck roof party shabby chic
 *       cardigan. Af mlkshk jean shorts disrupt williamsburg tattooed banh mi
 *       four loko small batch air plant cloud bread schlitz. Palo santo disrupt
 *       DIY mixtape tacos raw denim aesthetic gentrify. Meggings flexitarian
 *       crucifix pok pok cornhole, marfa jean shorts plaid mustache shoreditch.
 *     </Card>
 *   )
 * }
 * ```
 */
export const Card = memo(Component)
